import './FieldSet.css';
export var fieldset = '_aql7dv0-2-0-1';
export var legend = '_aql7dv1-2-0-1';